const sizeConfigs = {
  sidebar: {
    width: "230px"
  }
};

export default sizeConfigs;